<script setup>
import { ref, onBeforeMount, computed } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useAreasStore } from "@/stores/areas";
import { useUiStore } from "@/stores/ui";
// import "leaflet/dist/leaflet.css";
// import * as L from 'leaflet';
// import 'leaflet.markercluster/dist/MarkerCluster.css';
// import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
// import "leaflet.markercluster";
// import icon from '@/assets/images/location_icon.png'
// const markers = L.markerClusterGroup();

const props = defineProps({
  storesOptions: Array,
});

const areasStore = useAreasStore();
const uiStore = useUiStore();
const emit = defineEmits(["refresh"]);
const company_id = useCompanyStore().companyId;
const storeObj = ref(null);
const parent_location = ref(null);
let parentLocations = ref([]);
let description = ref(null);
let id = ref(null);
let name = ref(null);
let latitude = ref(null);
let longitude = ref(null);
let isSubmitted = ref(false);
let isLoadingParentLocations = ref(false);
// const initialMap = ref(null);
const getModalInfo = computed(() => uiStore.modalData);
const getModalAction = computed(() => uiStore.modalAction);
// import * as GeoSearch from 'leaflet-geosearch';

// const myIcon = L.icon({
//   iconUrl: icon,
//   iconSize: [30, 30],
//   iconAnchor: [15, 30],
//   popupAnchor: [-3, -76],
//   shadowSize: [60, 30],
//   shadowAnchor: [22, 94]
// });

const changeStoreVal = () => {
  parent_location.value = null;
  parentLocations.value = [];
  if (storeObj.value) {
    isLoadingParentLocations.value = true;
    areasStore
      .fetchParentAreas({
        siteId: storeObj.value,
        companyId: company_id,
      })
      .then(() => {
        //        parentLocations.value = res.data;
        isLoadingParentLocations.value = false;
      });
  }
};

const resetData = () => {
  storeObj.value = null;
  name.value = null;
  latitude.value = null;
  longitude.value = null;
  description.value = null;
  parent_location.value = null;
  parentLocations.value = [];
  isLoadingParentLocations.value = false;
  isSubmitted.value = false;
};

const onSubmit = () => {
  isSubmitted.value = true;
  const data = {
    id: id.value,
    name: name.value,
    latitude: latitude.value.toString(),
    longitude: longitude.value.toString(),
    description: description.value,
    site_id: storeObj.value,
    parent_id: parent_location.value,
    company_id,
  };

  areasStore
    .editArea(data)
    .then(() => {
      resetData();
      resetStoreData();
      emit("refresh");
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

const resetStoreData = () => {
  uiStore.resetModalStore();
};

// const pickLocation = async (e) => {
//if (layer instanceof L.Marker) {
//       await layer.remove();
//     }
//   });

//   let marker = new L.marker([e.latlng.lat , e.latlng.lng], {icon: myIcon})
//   .bindTooltip(`lat: ${e.latlng.lat} <br> long: ${e.latlng.lng}`)
//   .bindPopup(`lat: ${e.latlng.lat} <br> long: ${e.latlng.lng}`)
//   .addTo(initialMap.value);

//   markers.addLayer(marker);
//   initialMap.value.addLayer(markers);

//   initialMap.value.latLngToLayerPoint([e.latlng.lat , e.latlng.lng])

//   latitude.value = e.latlng.lat;
//   longitude.value = e.latlng.lng;
// }

// onMounted(()=> {
// if(getModalInfo.value && getModalAction.value == 'edit_location'){
//     setTimeout(async () => {

//       initialMap.value = L.map('editMapArea', {zoomControl: true,zoom:1,zoomAnimation:false,fadeAnimation:true,markerZoomAnimation:true}).setView([latitude.value ,longitude.value], 20);
//       initialMap.value.on('click', pickLocation);

//       let marker = L.marker([latitude.value ,longitude.value], {icon: myIcon})
//       .bindTooltip(`${name.value} `)
//       .bindPopup(` ${name.value} `)
//       .addTo(initialMap.value);

//       await markers.clearLayers();
//       markers.addLayer(marker);

//       L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
//         maxZoom: 19,
//       }).addTo(initialMap.value);

//       const search = new GeoSearch.GeoSearchControl({
//         provider: new GeoSearch.OpenStreetMapProvider(),
//       });

//       initialMap.value.addControl(search);
//       await markers.clearLayers();

//     },500);
//   }
// });

onBeforeMount(() => {
  if (
    getModalInfo.value &&
    getModalInfo.value.data_type == "area" &&
    getModalAction.value == "edit_location"
  ) {

    storeObj.value = getModalInfo.value.site_id;

    id.value = getModalInfo.value.id;
    name.value = getModalInfo.value.name;
    latitude.value =
      getModalInfo.value.metadata && getModalInfo.value.metadata.latitude
        ? Number(getModalInfo.value.metadata?.latitude)
        : "";
    longitude.value =
      getModalInfo.value.metadata && getModalInfo.value.metadata.longitude
        ? Number(getModalInfo.value.metadata?.longitude)
        : "";
    description.value = getModalInfo.value.description && getModalInfo.value.description != '-' ? getModalInfo.value.description : "";

    isLoadingParentLocations.value = true;

    areasStore
      .fetchParentAreas({
        siteId: getModalInfo.value.site_id,
        companyId: company_id,
      })
      .then((res) => {
        if (res.data && res.data.length) {
          parentLocations.value = res.data.filter((area) => {
            if (area.id != getModalInfo.value.id) {
              if (getModalInfo.value.parent_id) {
                parent_location.value = area.id;
              }
              return area;
            }
          });
        }
        isLoadingParentLocations.value = false;
      });
  }
});
</script>

<template>
  <DModal v-if="getModalAction === 'edit_location'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Edit Location </template>

    <template #body>
      <!-- <div class="mb-3">
        <span class="map-hint">Please pick up the area location on the map</span>
      </div>
  
      <div class="map-card p-0 mb-3">
        <div id="editMapArea" style="height:34vh;"></div>
      </div> -->

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="storeObj"
          inputId="storeObj"
          :options="props.storesOptions"
          :disabled="!props.storesOptions.length"
          optionLabel="name"
          optionValue="id"
          class="w-full"
          @change="changeStoreVal"
          filter
          filterPlaceholder="Search by site name"
        />
        <label for="role">Site</label>
      </FloatLabel>

      <div class="mb-3">
        <DInput :value="name" @input="name = $event.target.value" label="Location Name" width="100%" />
      </div>

      <FloatLabel class="w-full mb-3">
        <PTextarea
          v-model="description"
          id="editDescription"
          class="d-textarea resize-none h-105 w-full"
          autoResize
        />
        <label for="editDescription">Description</label>
      </FloatLabel>

      <!-- <div class="relative mb-3">
        <span v-if="parent_location" class="multiselect-title-span"
          >Parent Location</span
        >
        <VMultiselect
          v-model="parent_location"
          :options="parentLocations"
          trackBy="id"
          label="name"
          :disabled="true"
          :loading="isLoadingParentLocations"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Parent Location"
        />
      </div> -->

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="parent_location"
          inputId="parentLocation"
          :options="parentLocations"
          :disabled="!storeObj || isLoadingParentLocations"
          optionLabel="name"
          optionValue="id"
          class="w-full"
          filter
          filterPlaceholder="Search by location name"
          :loading="isLoadingParentLocations"
        />
        <label for="parentLocation">Parent Location</label>
      </FloatLabel>

      <p class="delete-text">
        <b>Note:</b> To change the location’s parent, click the action “Move
        Location” from the "Stores & Kiosks" page.
      </p>
    </template>
    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            :disabled="!storeObj || !name || isSubmitted"
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Edit
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"
          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
